<template>
  <div class="credit-usage-summary">
    <div
      v-for="({ width, color, position }, idx) in computedBars"
      :key="idx"
      class="credit-usage-summary__bar"
      :class="{ 'credit-usage-summary__bar--last': idx === lastNonZeroBarIndex }"
      :style="{
        width: `${width}%`,
        left: `${position}%`,
        backgroundColor: color,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  bars: { value: number; color: string }[]
  total: number
}>()

const computedBars = computed(() => {
  let currentPosition = 0

  return props.bars.map(({ value, color }) => {
    const position = currentPosition
    const width = props.total === 0 ? 0 : (value / props.total) * 100
    currentPosition += width

    return { width, color, position }
  })
})

const lastNonZeroBarIndex = computed(() => {
  for (let i = props.bars.length - 1; i >= 0; i--) {
    if (props.bars[i].value !== 0) {
      return i
    }
  }
  return -1
})
</script>

<style lang="scss" scoped>
.credit-usage-summary {
  position: relative;
  height: var(--size-2);
  width: 100%;
  background: var(--color-background-gray-subtle);
  border-radius: var(--size-4);
  overflow: hidden;

  &__bar {
    position: absolute;
    height: 100%;

    &--last {
      border-top-right-radius: var(--size-4);
      border-bottom-right-radius: var(--size-4);
    }
  }
}
</style>
